import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import BugsnagPerformance from "@bugsnag/browser-performance";
import React from "react";
import { startAnalytics } from "@/lib/analytics";

const apiKey = process.env.NEXT_PUBLIC_BUGSNAG_API_KEY;
const releaseStage = process.env.NEXT_PUBLIC_BUGSNAG_RELEASE_STAGE ?? "local";
const appVersion = process.env.NEXT_PUBLIC_APP_VERSION;

if (!apiKey) {
  console.warn("[bugsnag] NEXT_PUBLIC_BUGSNAG_API_KEY not set — error reporting disabled");
} else {
  try {
    Bugsnag.start({
      apiKey,
      plugins: [new BugsnagPluginReact(React)],
      releaseStage,
      enabledReleaseStages: ["local", "development", "production"],
      appVersion,
    });
    BugsnagPerformance.start({
      apiKey,
      releaseStage,
      appVersion,
    });
  } catch (err) {
    console.warn("[bugsnag] initialisation failed", err);
  }
}

startAnalytics();
